import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Row, Col, InputGroup, Progress, FormText, CardTitle, Card, CardHeader, Alert, CardBody, FormGroup, Label, Form, Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import LoadingIndicator from '../../utils/LoadingIndicator';
import moment from 'moment'
import {ajaxWrapperPost} from "../../utils/deviceAPI";

const propTypes = {
    sites: PropTypes.array,
};
const defaultProps = {
    sites: []
};


class Preferredsite extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true
        };
        this.handleChange = this.handleChange.bind(this);
    }
    componentDidMount() {
        this.setState({
            loading: false,
            preferredSite: this.props.preferredSite
        })

    }
    handleChange({ target }) {
        this.setState({
            [target.id] : target.value
        })
    }

    render() {
        return (
            <Col xs="12">
                <Card>
                    <CardBody className="card-body">
                        <Row className="pb-4">
                            <Col sm="10">
                                <CardTitle className="mb-1">Preferred Site</CardTitle>
                                <div className="small text-muted">Select which site's overview you would like to see when logging in. </div>
                            </Col>
                            <Col sm="2" className="d-none d-sm-inline-block">
                                <i className="fa fa-list float-right text-secondary"></i>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs="12" sm="12" lg="8" xl="8" className="mb-1">
                                <FormGroup>
                                    <Input type="select" name="preferredSite" id="preferredSite" value={this.state.preferredSite} onChange={ this.handleChange }>
                                        <option value="Dashboard">Dashboard</option>
                                        {this.props.sites.map((site,index) => {
                                            return (
                                                <option key={index} value={`${site.deviceName}`}>{site.siteName}</option>
                                            )
                                        })}
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col xs="12" sm="12" lg="4" xl="4">
                                <Button block color="primary" className="text-white mr-3" disabled={this.state.preferredSite === this.props.preferredSite} onClick={() => this.props.prefferedSiteSet(this.state.preferredSite)}>Accept</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Col>
        )

    }
}
Preferredsite.propTypes = propTypes;
Preferredsite.defaultProps = defaultProps;

export default Preferredsite;



// WEBPACK FOOTER //
// ./src/components/Sitelist/Preferredsite.js